import React, { FunctionComponent } from "react"
import { AnchorLinkClass } from "../../styles/tailwind.helpers"

export const AboutIndexPage: FunctionComponent = (props) => (
    <div className={`p-12 flex-1 flex flex-col items-left`}>
        <div className={`my-auto flex place-content-center`}>
            <div className={`max-w-prose`}>
                <h1 className={`font-merriweather font-bold text-5xl subpixel-antialiased`}>Jasmine</h1>
                <div className={`my-12 space-y-8`}>
                    <div className={`my-12 space-y-4`}>
                        <div className={`my-12 space-y-4`}>
                            <h2 className={`font-merriweather font-bold text-3xl subpixel-antialiased`}>
                                What is Jasmine?
                            </h2>
                            <p className={`font-sourceSansPro subpixel-antialiased text-lg`}>
                                Jasmine is a conversational search engine that provides answers to legal questions. It
                                can often be difficult to start legal research with so many primary and secondary
                                sources to choose from. To solve this problem, JADE has built a search engine tailored
                                to the needs of the ordinary legal researcher.
                            </p>
                            <p className={`font-sourceSansPro subpixel-antialiased text-lg`}>
                                After asking a question, Jasmine recommends a variety of judgments which we anticipate
                                have discussed answers to the query. For most questions, these results will either
                                discuss the applicable principles or relevant statutory regime. But this entirely
                                depends on the question asked.
                            </p>
                            <p className={`font-sourceSansPro subpixel-antialiased text-lg`}>
                                For example, asking Jasmine <a className={AnchorLinkClass} href='/search/When%20is%20coincidence%20evidence%20admissible?filters=&method=semantic' target='_blank'>“when is coincidence evidence admissable?”</a> returns
                                results about when coincidence evidence may be admissible in a matter. Some questions might return poor
                                results with one query, but good results with another. It is always well advised to
                                experiment with different types of questions on the topic being researched.
                            </p>
                        </div>
                    </div>
                    <div className={`my-12 space-y-4`}>
                        <h2 className={`font-merriweather font-bold text-3xl subpixel-antialiased`}>
                            How does Jasmine find relevant passages?
                        </h2>
                        <p className={`font-sourceSansPro subpixel-antialiased text-lg`}>
                            Jasmine leverages cutting edge natural language search techniques that do not rely on
                            traditional literal keyword matches. This means Jasmine can understand the underlying
                            concepts discussed by judges to provide the best pinpoint reference to your query. While
                            some topics cover multiple areas of law, for instance penalties in contract and criminal
                            law, usually a few on-topic results can be recognised and evaluated from the range returned.
                        </p>
                        <p className={`font-sourceSansPro subpixel-antialiased text-lg`}>
                            As Jasmine is developed with legally trained people at the fore, typically the best results
                            will be generated from thoughtful questions. But this does not necessarily mean you need to
                            be a lawyer to use Jasmine. Jasmine will try to answer all types of questions. For instance,
                            try <a className={AnchorLinkClass} href='/search/how%20do%20I%20get%20away%20with%20murder?filters=&method=semantic' target='_blank'>“how do I get away with murder?”</a> and see what happens!
                        </p>
                        <p className={`font-sourceSansPro subpixel-antialiased text-lg`}>
                            By understanding the underlying semantic meaning of your question, Jasmine is able to find
                            exact paragraphs to formulate the best available response.
                        </p>
                    </div>
                    <div className={`my-12 space-y-4`}>
                        <h2 className={`font-merriweather font-bold text-3xl subpixel-antialiased`}>
                            How is my search history used?
                        </h2>
                        <p><strong>It isn&apos;t.</strong> We do not keep a history of your search input.</p>
                        <p className={`font-sourceSansPro subpixel-antialiased text-lg`}>
                            At JADE, we value your privacy.
                        </p>
                        <p className={`font-sourceSansPro subpixel-antialiased text-lg`}>Jasmine does not:</p>
                        <ul className={`ml-12 list-disc`}>
                            <li className={`font-sourceSansPro subpixel-antialiased text-lg`}>
                                use your search history to generate better results
                            </li>
                            <li className={`font-sourceSansPro subpixel-antialiased text-lg`}>
                                send your search history to third parties
                            </li>
                            <li className={`font-sourceSansPro subpixel-antialiased text-lg`}>
                                store your history for debugging purposes
                            </li>
                            <li className={`font-sourceSansPro subpixel-antialiased text-lg`}>
                                recommend your searches to other users
                            </li>
                        </ul>
                        <p className={`font-sourceSansPro subpixel-antialiased text-lg`}>
                            Your search input is only used to find a list of answers and is not retained. As
                            every search is unique, we cannot determine what search generates a particular list of
                            results. And because Jasmine evolves as new cases are added, a search completed last week
                            might not provide the same results as this week.
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </div>
)

export default AboutIndexPage
